import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Col, Row, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Heading5, Icon, SearchInput } from '../../widgets';
import AssignedCustomerList from './AssignedCustomerList';
import { searchWord } from '../../../helpers/common';
import { getFarmCustomerList, getUserCustomerList, saveCustomerUser } from '../../../actions/customer';

const AssignCustomerModal = props => {
    const { onHide, userId } = props;
    const [assignedCustomerIds, assignCustomer] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [searchText, setSearchText] = useState("");

    const dispatch = useDispatch();

    const { payload: farmCustomerList } = useSelector((state => state.customer.farmCustomerList));
    const { payload: userCustomerList, isRequesting: userCustomerRequsting } = useSelector((state => state.customer.userCustomerList));


    useEffect(() => {
        if (userCustomerList && userCustomerList.length > 0) {
            assignCustomer(userCustomerList.map(item => item.customer_uuid));
        }
    }, [userCustomerList]);

    useEffect(() => {
        dispatch(getFarmCustomerList());
        dispatch(getUserCustomerList({ user_id: userId }));
    }, []);

    const handleSave = () => {
        const params = { user_id: userId, customer_uuid: assignedCustomerIds };

        const onSuccess = () => {
            setIsSaving(false);
            dispatch(getUserCustomerList({ user_id: userId }))
            onHide();
        };

        setIsSaving(true);
        dispatch(saveCustomerUser(params, onSuccess));
    }

    const handleAssignCustomer = (customerId) => assignCustomer([...assignedCustomerIds, customerId]);

    const handleUnassignCustomer = (customerId) => {
        assignedCustomerIds.splice(assignedCustomerIds.indexOf(customerId), 1);
        assignCustomer([...assignedCustomerIds])
    };


    const getFilteredCustomerList = (farmCustomerList, searchText) => {
        return farmCustomerList.filter(e => (assignedCustomerIds.indexOf(e.customer_uuid) < 0 && searchWord(e.customer_name, searchText)));
    }
    let filteredCustomerList = useMemo(() => getFilteredCustomerList(farmCustomerList, searchText), [farmCustomerList, assignedCustomerIds, searchText]);



    return <Modal show={true} backdrop="static" onHide={onHide} size='xl' className="assign-farm-modal">
        <Modal.Header closeButton style={{ color: '#064d9e' }}>
            <Modal.Title >
                <Heading5>
                    Assign Customer
                </Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                <AssignedCustomerList isRequesting={userCustomerRequsting} userId={userId}
                    assignedCustomerIds={assignedCustomerIds}
                    handleUnassignCustomer={handleUnassignCustomer}
                    assignCustomer={assignCustomer}
                // organizationListById={organizationListById}
                />
                <Col sm={4} md={4} lg={4} className="available-farms">
                    <div className="search-input">
                        <SearchInput className="w-100" onChange={searchText => setSearchText(searchText)} />
                    </div>
                    <div className={`m-0 farm-items`}>
                        {filteredCustomerList.map(item => <Card key={item.customer_uuid} className="farm-item">
                            <div>
                                <Row className="name m-0">{item.customer_name}</Row>
                                {item.farm_name && <Row className="sub-name m-0"> {item.farm_name}</Row>}
                            </div>
                            <Button className="btn-success btn-sm add-btn" title={"Assign Farm"}
                                onClick={() => handleAssignCustomer(item.customer_uuid)}>Add</Button>
                        </Card>
                        )}
                    </div>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='btn btn-danger btn-sm' onClick={onHide} ><i className="fa fa-times-circle"></i> Cancel</Button>
            <Button variant='btn  btn-primary btn-sm' onClick={handleSave} ><Icon className="fa fa-floppy-o"></Icon>{isSaving ? " Saving..." : " Save"}</Button>
        </Modal.Footer>
    </Modal>
};

export default AssignCustomerModal;